export default __webpack_public_path__ + "static/media/work1.25b21658.jpg";